import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b7d7ef7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "day-experience" }
const _hoisted_2 = { class: "experiences" }
const _hoisted_3 = { class: "experiences-container" }
const _hoisted_4 = {
  key: 0,
  class: "empty"
}

import BaseSpinner from "@/components/base/BaseSpinner.vue";
import SearchBar from "@/components/dayExperience/SearchBar.vue";
import SingleExperience from "@/components/dayExperience/SingleExperience.vue";
import useDayExperienceQuery from "@/composables/queries/useDayExperienceQuery";
import useTaxonomiesQuery from "@/composables/queries/useTaxonomiesQuery";


export default /*#__PURE__*/_defineComponent({
  __name: 'dayExperience',
  setup(__props) {

const { data: taxonomies } = useTaxonomiesQuery();
const { data: experiences, isLoading, setFilter } = useDayExperienceQuery();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(taxonomies))
      ? (_openBlock(), _createBlock(SearchBar, {
          key: 0,
          islandOptions: _unref(taxonomies).islands,
          categoryOptions: _unref(taxonomies).categories,
          onSearch: _unref(setFilter)
        }, null, 8, ["islandOptions", "categoryOptions", "onSearch"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(isLoading))
          ? (_openBlock(), _createBlock(BaseSpinner, {
              key: 0,
              size: 40,
              class: "loader"
            }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(experiences), (exp, index) => {
              return (_openBlock(), _createBlock(SingleExperience, {
                key: index,
                experience: exp
              }, null, 8, ["experience"]))
            }), 128))
      ]),
      (!_unref(isLoading) && !_unref(experiences)?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Could not find any matching results, try adjusting your search. "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})